import Img1 from '../img/img1.jpg';
import Img4 from '../img/img4.jpg';

const aboutUsPage = [
    {
      description: 'Crystal Clear Pool & Spa Service has been offering quality pool maintenance and pool repair services for many years. While large enough to serve the greater St. Helena area, we are proud to offer personalized and attentive services to each and every one of our customers. At Crystal Clear Pool & Spa Service, we believe in treating our esteemed clients with the level of respect and care they deserve, regardless of the size of their project – or budget.',
      image: Img1,
      id: 'n984jgo'
    },
    {
      description: 'Our team is comprised of highly trained and experienced pool technicians, ensuring that each and every maintenance and repair project is carried out quickly, efficiently and professionally. Our crew is courteous and respectful of your environment and privacy, which is why we strive to stay out of your way as much as possible and always try to accommodate the schedule that works best for you. Our goal is to work as hard and as quickly as possible to allow you to enjoy your swimming pool as much and as often as you like.',
      image: Img4,
      id: 'kj3ljf'
    }
  ];

  export default aboutUsPage;